// eslint-disable-next-line
import Register from "./components/Register";
import ipConfig from "./ipConfig.json";
// eslint-disable-next-line
import { Route, Switch } from "react-router-dom";
// eslint-disable-next-line
import Login from "./components/Login";
// eslint-disable-next-line
import Products from "./components/Products";
import React from "react"
import theme from "./theme"
import Checkout from "./components/Checkout"
import Thanks from './components/Thanks'
import { ThemeProvider } from "@mui/material";

export const config = {
  endpoint: `https://qkart-frontend2-ahrs.onrender.com/api/v1`,
};

function App() {
  return (
    <React.StrictMode>

      <ThemeProvider theme={theme}>
    <div className="App">
      {/* TODO: CRIO_TASK_MODULE_LOGIN - To add configure routes and their mapping */}
      <Switch>
          <Route exact path="/" component={Products}/>
          <Route path="/register" component={Register} />
          <Route path="/login" component={Login} />
          <Route path="/checkout" component={Checkout} />
          <Route path="/thanks" component={Thanks} />
        </Switch>
         </div>
    </ThemeProvider>
    </React.StrictMode>
  );
}

export default App;
